<template>
  <div class="form-wrapper">
    <h1>Assign Role to User</h1>
    <form @submit="handleSubmit">
      <label for="user-id">User ID or User Email</label>
      <input
        id="user-id"
        ref="userIdInput"
        v-model="userId"
        class="p-3 border"
        autofocus
        placeholder="Enter user id or email"
        required
        type="text"
      />
      <label for="role-id">Select Role</label>
      <VueSelect
        id="role-id"
        placeholder="Select Role"
        label="name"
        :options="allRoles"
        :reduce="role => role.name"
        @change="handleChange"
      />

      <button
        class="button-green link border p-3 px-12 rounded-full bg-green text-white font-bold"
      >
        Assign Role
      </button>
    </form>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"

export default {
  components: {
    VueSelect,
  },
  data() {
    return {
      userId: "",
      roleId: "",
      allRoles: [],
    }
  },
  created() {
    this.axios({
      method: "get",
      url: `${siteConfig.siteURL}admin/roles?pagination=false`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-access-token": localStorage.token,
      },
    })
      .then(res => {
        this.allRoles = res.data.items
      })
      .catch(err => {
        this.$noty.error(
          `Couldn't not get all roles from server, server responded with: ${err}`
        )
      })
  },
  mounted() {
    this.$refs.userIdInput.focus()
  },
  methods: {
    handleChange(option) {
      if (option) {
        this.roleId = option.id
      } else {
        this.roleId = ""
      }
    },
    handleSubmit(e) {
      if (!this.roleId) {
        this.$noty.error("Please select role")
        return
      }
      if (!this.userId) {
        this.$noty.error("Please provide user id or email")
        return
      }
      e.preventDefault()
      this.assignRoleToUser()
    },
    async assignRoleToUser() {
      const payload = {
        role_id: this.roleId,
      }
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}admin/grant_role/${this.userId}`,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          this.$noty.success(res.data.message)
          console.log(res)
        })
        .catch(err => {
          this.$noty.error(
            `Something went wrong while assigning role, server responded with:${err}`
          )
        })
    },
  },
}
</script>

<style scoped>
.form-wrapper {
  max-width: 500px;
  margin: auto;
  margin-top: 80px;
}
input {
  display: block;
  width: 100%;
  margin: auto;
  padding: 10px;
  border-radius: 5px;
  font-size: 16px;
}

label {
  display: block;
  padding: 10px 0px;
  font-size: 16px;
  text-align: left;
}
button {
  display: block;
  margin: 10px auto;
  text-align: center;
}
</style>
